import React from 'react'
import QRCode from 'react-qr-code'
import { useSelector } from 'react-redux'
import {ESignaturePaneProps} from "./ESignaturePane";

export const ESignatureQRCodeDisplay = ({ id, guid, code, type }:ESignaturePaneProps) => {
  const { signatureFormURL } = useSelector((state) => state?.application)
  const url = `${signatureFormURL}/${type}/${id}/${code}/${guid}`
  return (
    <div className="token-view mx-auto col-sm-8 col-sm-4">
      <div className="text-center">
        <h2>PLEASE SCAN THIS QR CODE</h2>
        <h5>
          To obtain Signature for {type.toUpperCase()} - {code}{' '}
        </h5>
      </div>
      <div className="mt-3 mb-3 text-center">
        <QRCode size={400} value={url} />
      </div>
      <strong>{url}</strong>
    </div>
  )
}
